(() => {
  'use strict';
  const bind = (root) => {
    root.querySelectorAll('[data-ace-case-hover-peek]').forEach((frame) => {
      if (frame.dataset.aceCaseBound) return;
      frame.dataset.aceCaseBound = 'true';
      const photo = frame.querySelector('.ace-case__photo-link') || frame;
      let pointerInside = false;
      let keyboardInside = false;
      let lastPointerType = '';
      const show = () => frame.toggleAttribute('data-ace-case-active', pointerInside || keyboardInside);
      photo.addEventListener('pointerenter', (event) => {
        lastPointerType = event.pointerType || 'mouse';
        if (lastPointerType === 'touch') return;
        pointerInside = true;
        show();
      });
      photo.addEventListener('mouseenter', () => {
        if (lastPointerType === 'touch') return;
        pointerInside = true;
        show();
      });
      const leave = () => {
        pointerInside = false;
        lastPointerType = '';
        show();
      };
      photo.addEventListener('pointerleave', leave);
      photo.addEventListener('mouseleave', leave);
      photo.addEventListener('pointercancel', leave);
      photo.addEventListener('focusin', () => {
        keyboardInside = true;
        show();
      });
      photo.addEventListener('focusout', (event) => {
        keyboardInside = photo.contains(event.relatedTarget);
        show();
      });
    });
  };
  const init = () => bind(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
